import { LanguageService } from './../services/language.service';
import { ContractListPipe } from './../pipes/contract-list.pipe';
import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
import { LocalStorageService } from './../services/local-storage.service';
import { Contract } from './../interfaces/contract.model';
import { CompanyService } from './../services/company.service';
import { Company } from '../interfaces/company.model';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ContractsService } from './../services/contracts.service';
import { Component, OnInit } from '@angular/core';

import '../../assets/js/scripts.js';
import { DateService } from '../services/date.service';

declare var Project: any;

@Component({
  selector: 'app-contract-list',
  templateUrl: './contract-list.component.html',

})
export class ContractListComponent implements OnInit {
  dates = { start: '1', end: '2' };


  p: number = 1;

  company: Company;
  contractsListLoading: Boolean = true;
  contracts: any = {};
  contractNameValue = '';

  constructor(
    private contractsService: ContractsService,
    private localStorageService: LocalStorageService,
    private companyService: CompanyService,
    private breadcrumbService: BreadcrumbService,
    private languageService: LanguageService,
    private dateService: DateService,
  ) { 
    this.breadcrumbService.addFriendlyNameForRoute('/contracts/list', 'Lista kontraktów');
  }


  ngOnInit() {
    this.contractsService.getCompanyContracts(this.localStorageService.get('company')).subscribe(
      (contracts: Contract[]) => {
        this.contracts = contracts;
        this.contractsListLoading = false;
        // console.log(this.contracts);
      }
    );
  }

 ngAfterViewInit() {
    // console.log('after init');
  }
}



// WEBPACK FOOTER //
// ./src/app/contract/contract-list.component.ts